/** 英语四六级等情况 */
export const CET_LEVEL_OPTIONS = [
  '未考过',
  '四级',
  '六级',
  '专四',
  '专八',
  '其他',
]

/** 备考难题（多选） */
export const PREP_DIFFICULTY_OPTIONS = [
  '英语基础薄弱',
  '专业课没方向',
  '工作忙没时间',
  '担心论文答辩',
  '其他',
]

/** 备考时长 */
export const PREP_DURATION_OPTIONS = [
  '30分钟以下',
  '1-2小时',
  '3小时以上',
]
